import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { Training } from "./routes";
export default store => ({
  path: ":curriculumProgramId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "toddleAnalytics" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [Training(store)],
});
